"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import _ from "lodash";
import { APIDataSource } from "@/components/grid/data-source";
import LoginLogSearchForm from "./search/LoginLogSearchForm.vue";
import { UiFormController } from "@/components/form/UiForm.vue";
import DateFormat from "@/framework/timeformatter";
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.operatorName = null;
    this.expiryDate = [];
    this.loginIp = null;
    this.loginRegion = null;
  }
}
let LoginLogs = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/loginLogs")
    );
    this.formcontroller = new FormController();
    this.searchStr = "";
    this.searchStr_dates = null;
    this.searchDate = [
      // new Date().setMonth(new Date().getMonth() - 3),
      new Date(new Date().getTime() - 3600 * 1e3 * 24 * 7),
      new Date()
    ];
    this.searchDate_dates = null;
    this.searchParams = {
      search: "",
      select: null
    };
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.setMonth(start.getMonth() - 1)).setDate(1)
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
        ) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = `operatorName=='%${searchStr}%'`;
        this.searchAllData();
        return;
      }
      if (searchStr === null || searchStr === "") {
        this.searchStr_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchByDate = _.debounce((searchDate) => {
      if (searchDate !== null && searchDate.length > 0) {
        let mintime = Date.parse(searchDate[0]);
        let maxtime = Date.parse(searchDate[1]);
        this.searchDate_dates = `createdTime>=${mintime};createdTime<=${maxtime}`;
        this.searchAllData();
        return;
      }
      if (searchDate === null || searchDate.length === 0) {
        this.searchDate_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchAllData = _.debounce(() => {
      try {
        this.gridController.query.current = 1;
        this.clearDrawer();
        this.searchParams = {
          search: "",
          select: null
        };
        if (this.searchDate_dates !== null) {
          this.searchParams.search = this.searchDate_dates;
          if (this.searchStr_dates !== null) {
            let obj = `${this.searchDate_dates};${this.searchStr_dates}`;
            this.searchParams.search = obj;
          }
        }
        if (this.searchDate_dates === null || this.searchDate_dates === "") {
          this.searchParams = {
            search: "",
            select: null
          };
          if (this.searchStr_dates !== null) {
            this.searchParams.search = this.searchStr_dates;
          }
        }
        this.gridController.query.params = this.searchParams;
        this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    }, 500);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.filter = "";
      yield this.searchByDate(this.searchDate);
    });
  }
  clearDrawer() {
    this.formcontroller = new FormController();
    this.gridController.query.params = {
      search: "",
      select: null
    };
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams.search = query;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      yield this.clearSearch();
      const _advancedSearchForm = LoginLogSearchForm.create(this.formcontroller);
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  clearSearch() {
    return __async(this, null, function* () {
      if (this.searchStr !== "" && this.searchStr !== null || this.searchDate && this.searchDate.length > 0) {
        this.searchStr = "";
        this.searchDate = [];
        this.clearDrawer();
        yield this.gridController.search();
      }
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
};
LoginLogs = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], LoginLogs);
export {
  LoginLogs as default
};
